import React, { useState } from "react"
import EventPage1 from "./EventPage1"
import EventPage2 from "./EventPage2"
import EventPage3 from "./EventPage3"

const CreateEvent = () => {
  const [formStep, setFormStep] = useState(1)

  switch (formStep) {
    case 1:
      return <EventPage1 formStep={setFormStep} />
    case 2:
      return <EventPage2 formStep={setFormStep} />
    case 3:
      return <EventPage3 />
    default:
      return <EventPage1 />
  }
}

export default CreateEvent
